__turbopack_context__.v({
  "animatedElement": "Animate-module__AclSJW__animatedElement",
  "clipPathIn": "Animate-module__AclSJW__clipPathIn",
  "delay-100": "Animate-module__AclSJW__delay-100",
  "delay-200": "Animate-module__AclSJW__delay-200",
  "delay-300": "Animate-module__AclSJW__delay-300",
  "delay-400": "Animate-module__AclSJW__delay-400",
  "delay-500": "Animate-module__AclSJW__delay-500",
  "fadeIn": "Animate-module__AclSJW__fadeIn",
  "rotateIn": "Animate-module__AclSJW__rotateIn",
  "scaleIn": "Animate-module__AclSJW__scaleIn",
  "slideDown": "Animate-module__AclSJW__slideDown",
  "slideLeft": "Animate-module__AclSJW__slideLeft",
  "slideRight": "Animate-module__AclSJW__slideRight",
  "slideUp": "Animate-module__AclSJW__slideUp",
});
